import { render, staticRenderFns } from "./LevelUnlockSettings.vue?vue&type=template&id=b4c3a642"
import script from "./LevelUnlockSettings.vue?vue&type=script&lang=js"
export * from "./LevelUnlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports